.qrWrapper {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
}

.qrContainer {
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
}

.qrCornerTopLeft {
	position: absolute;
	top: 0;
	left: 0;

	border-top: 8px solid #dae9ed;
	border-left: 8px solid #dae9ed;
}

.qrCornerTopRight {
	position: absolute;
	top: 0;
	right: 0;
	border-top: 8px solid #dae9ed;
	border-right: 8px solid #dae9ed;
}

.qrCornerBottomLeft {
	position: absolute;
	bottom: 0;
	left: 0;

	border-bottom: 8px solid #dae9ed;
	border-left: 8px solid #dae9ed;
}

.qrCornerBottomRight {
	position: absolute;
	bottom: 0;
	right: 0;

	border-bottom: 8px solid #dae9ed;
	border-right: 8px solid #dae9ed;
}

.description:global(.MuiTypography-root) {
	font-weight: 600;
	font-size: 0.9375rem;
	line-height: 1.5;
	color: #000000;
	text-align: center;
}
